import React, { useState } from "react";
import { useContext } from "react";
import styled from "styled-components";
import { DataContext } from "../../contexts/DataContext";
import { Button } from "../Lineup/LineupEditor";
import ConfirmModal from "../Modals/ConfirmModal";
import Panel from "../UI/Panel/Panel";
import PanelContent from "../UI/Panel/PanelContent";

const Main = styled.div`
  display: flex;
`;

function Admin() {
  const { deleteSquads } = useContext(DataContext);
  const [confirmDelete, setConfirmDelete] = useState(false);

  return (
    <Main>
      <Panel>
        <PanelContent>
          <Button
            onClick={() => {
              setConfirmDelete(true);
            }}
          >
            Rebuild Squads
          </Button>
        </PanelContent>
      </Panel>
      <ConfirmModal
        title="Are you sure you want to rebuld squad data?"
        show={confirmDelete}
        onConfirm={() => {
          deleteSquads();
          setConfirmDelete(false);
        }}
        onCancel={() => {
          setConfirmDelete(false);
        }}
      ></ConfirmModal>
    </Main>
  );
}

export default Admin;
